import { useNavigate } from "react-router-dom";

const POLICIES_URL = "https://www.azosis.com/gc/policies/policies.php";

const policyLinks = [
  "Privacy Policy",
  "Terms of Service",
  "GDPR",
  "DMCA",
  "Usage",
  "Billing",
];

const officeLinks = [
  { label: "azosis.in - India", href: "https://azosis.in" },
  { label: "azosis.us - USA", href: "https://azosis.us" },
  { label: "azosis.ae - UAE", href: "https://azosis.ae" },
  { label: "azosis.sg - Singapore", href: "https://azosis.sg" },
];

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="w-full px-6 md:px-10 lg:px-16 py-8 md:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">

          {/* Column 1 — Brand */}
          <div>
            <img
              src="/assets/azosis logo.webp"
              alt="Azosis Technologies"
              className="h-8 md:h-10 w-auto object-contain mb-4"
            />
            <p className="text-gray-600 text-sm mb-6">
              Trusted technology consulting and managed services - across India, USA, UAE, and Singapore.
            </p>
            <a
              href="https://www.linkedin.com/company/azosisintl"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 flex items-center justify-center border border-gray-200 rounded-sm text-gray-400 hover:text-azosis-gold hover:border-azosis-gold/50 transition-all"
            >
              <i className="ri-linkedin-fill text-sm"></i>
            </a>
          </div>

          {/* Column 2 — Navigation */}
          <div>
            <h4 className="text-gray-900 font-semibold text-sm tracking-wide mb-6 relative">
              Navigation
              <span className="absolute bottom-0 left-0 w-8 h-px bg-azosis-gold -mb-2"></span>
            </h4>

            <ul className="space-y-3">
              <li><button onClick={() => navigate("/")} className="text-gray-600 text-sm">Home</button></li>
              <li><button onClick={() => navigate("/services")} className="text-gray-600 text-sm">Services</button></li>
              <li><button onClick={() => navigate("/about")} className="text-gray-600 text-sm">About</button></li>
              <li><button onClick={() => navigate("/case-studies")} className="text-gray-600 text-sm">Case Studies</button></li>
              <li>
                <a
                  href="https://www.azosis.com/gc/contact.php"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 text-sm"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3 — Global Offices */}
          <div>
            <h4 className="text-gray-900 font-semibold text-sm tracking-wide mb-6 relative">
              Global Offices
              <span className="absolute bottom-0 left-0 w-8 h-px bg-azosis-gold -mb-2"></span>
            </h4>

            <ul className="space-y-3">
              {officeLinks.map((office) => (
                <li key={office.href}>
                  <a
                    href={office.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-600 text-sm hover:text-gray-900 transition-colors"
                  >
                    {office.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4 — Contact */}
          <div>
            <h4 className="text-gray-900 font-semibold text-sm tracking-wide mb-6 relative">
              Contact
              <span className="absolute bottom-0 left-0 w-8 h-px bg-azosis-gold -mb-2"></span>
            </h4>

            <ul className="space-y-3">
              <li>
                <a href="mailto:letstalk@azosis.com" className="text-gray-600 text-sm">
                  letstalk@azosis.com
                </a>
              </li>
              <li>
                <a
                  href="https://www.azosis.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 text-sm"
                >
                  www.azosis.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 mt-16 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-xs whitespace-nowrap">
            © 2026 Azosis Technologies. All rights reserved.
          </p>
          <div className="flex flex-wrap items-center justify-center sm:justify-end gap-x-4 gap-y-1">
            {policyLinks.map((label) => (
              <a
                key={label}
                href={POLICIES_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 text-xs hover:text-gray-900 transition-colors whitespace-nowrap"
              >
                {label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}